var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 48 57"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lock_svg__c",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#756bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4861ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7 0h39v53H7z",
    "data-name": "\\uC0AC\\uAC01\\uD615 17683"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-411 -105)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#lock_svg__\\uC0AC\\uAC01\\uD615_555)",
    transform: "translate(411 105)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#596ffc",
    strokeWidth: 2,
    "data-name": "\\uC0AC\\uAC01\\uD615 555",
    transform: "translate(13 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 31,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 29,
    x: 1,
    y: 1,
    rx: 9
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lock_svg__\\uC0AC\\uAC01\\uD615_553)",
    transform: "translate(411 105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#lock_svg__c)",
    d: "M4 0h22a4 4 0 0 1 4 4v12a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V4a4 4 0 0 1 4-4",
    "data-name": "\\uC0AC\\uAC01\\uD615 553",
    transform: "translate(9 21)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 11,
    fill: "#fff",
    "data-name": "\\uC0AC\\uAC01\\uD615 554",
    rx: 1,
    transform: "translate(434 130)"
  }))));
};
export default SvgLock;